<template>
  <div class="edit-campaign-budget-modal-ad-budget-info">
    <img
      class="edit-campaign-budget-modal-ad-budget-info__image"
      src="~@/assets/images/money.svg"
    />
    <div class="edit-campaign-budget-modal-ad-budget-info__budget-wrapper">
      <span>{{ $t('ADVERTISEMENT.CAMPAIGN_FINANCE.AVAILABLE_BUDGET') }}:</span>
      <span>
        <span class="edit-campaign-budget-modal-ad-budget-info__budget">
          {{ priceFormat(budgetAllocationLimit) }}
        </span>
        {{ $t('RIALS') }}
      </span>
      <RouterLink
        v-if="!budgetAllocationLimit"
        class="edit-campaign-budget-modal-ad-budget-info__add-credit-link"
        :to="{ name: 'finance-transactions' }"
      >
        {{ $t('ADVERTISEMENT.CAMPAIGN_FINANCE.ADD_TO_WALLET') }}
      </RouterLink>
    </div>
  </div>
</template>

<script>
import { format as priceFormat } from '@/utils/number';

export default {
  name: 'EditCampaignBudgetModalAdBudgetInfo',
  props: {
    budgetAllocationLimit: {
      type: Number,
      required: true,
    },
  },
  methods: {
    priceFormat,
  },
};
</script>

<style lang="scss">
.edit-campaign-budget-modal-ad-budget-info {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  &__image {
    width: rem-calc(64px);
  }

  &__budget-wrapper {
    padding: $global-padding 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    flex-wrap: wrap;

    align-self: stretch;
  }

  &__budget {
    font-weight: bold;
    font-size: $global-font-size * 2;
  }

  &__add-credit-link {
    margin-top: $global-margin;
  }
}
</style>
